(function() {
    'use strict';

    angular.module('allegro').controller(
        'AllegroCreateModificationCmdModalController', AllegroCreateModificationCmdModalController);

    AllegroCreateModificationCmdModalController.$inject = [
        '$uibModalInstance',
        'dataObj',
        'allegroAccountDataSrvc',
        'allegroOffersDataSrvc',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroOfferCmdMessageConst'
    ];

    function AllegroCreateModificationCmdModalController(
        $uibModalInstance, data, allegroAccountDataSrvc, allegroOffersDataSrvc, notificationSrvc, errorNotificationSrvc,
        allegroOfferCmdMessageConst
    ) {
        var self = this;

        self.loading = false;
        self.account = data.account;
        self.data = data;
        self.saving = false;
        self.deliveryHandlingTimeOpts = [];
        self.serverErrors = {
            modification: {
                delivery_handling_time: [],
            }
        };
        self.selectedDeliveryTime = null;

        self.getDeliveryHandlingTimes = getDeliveryHandlingTimes;
        self.formSubmit = formSubmit;
        self.modalClose = modalClose;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getDeliveryHandlingTimes(self.account.pk);
        }

        function getDeliveryHandlingTimes(accountId){
            return allegroAccountDataSrvc.getDeliveryHandlingTimes({pk: accountId}).$promise.then(
                function (response) {
                    self.deliveryHandlingTimeOpts = response;
                    return response;
                }
            )
        }

        function formSubmit() {
            self.saving = true;
            return allegroOffersDataSrvc.createModificationCmd({
                    offers: self.data.offers,
                    type: 'DELIVERY_HANDLING_TIME_MODIFICATION',
                    modification: {
                        delivery_handling_time: self.selectedDeliveryTime
                    }
                })
                .$promise
                .then(function (response) {
                    notificationSrvc.notification("success", allegroOfferCmdMessageConst.changeDeliveryTime);
                    $uibModalInstance.close(response);
                })
                .catch(function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function () {
                    self.saving = false;
                });
        }

        function modalClose() {
            $uibModalInstance.dismiss('cancel');
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
